import './publicPath'

const Vue = window.Vue
Vue.component('voucher-check', () => import('./VoucherCheck.vue'))
